"use strict";

exports.__esModule = true;
exports.default = virtualize;
var _react = _interopRequireDefault(require("react"));
var _VirtualList = _interopRequireWildcard(require("./VirtualList"));
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}
function virtualize(Widget) {
  var _class, _temp;
  var name = Widget.name || Widget.displayName || 'Widget';
  name = name[0] + name.slice(1);
  return _temp = _class = /*#__PURE__*/
  function (_React$Component) {
    _inheritsLoose(_class, _React$Component);
    function _class() {
      return _React$Component.apply(this, arguments) || this;
    }
    var _proto = _class.prototype;
    _proto.render = function render() {
      var _VirtualList$getVirtu = _VirtualList.default.getVirtualListProps(this.props),
        listProps = _VirtualList$getVirtu.listProps,
        props = _VirtualList$getVirtu.props;
      return _react.default.createElement(Widget, _extends({}, props, {
        listComponent: _VirtualList.default,
        listProps: listProps
      }));
    };
    return _class;
  }(_react.default.Component), _class.displayName = "Virtual" + name, _class.propTypes = _VirtualList.virtualListPropTypes, _temp;
}
module.exports = exports["default"];